import { differenceInCalendarDays } from 'date-fns'

function isSameDay(a, b) {
  return differenceInCalendarDays(a, b) === 0
}

export default isSameDay
